import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 170px 0px 0px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  background-color: var(--white);

  // CarouselTextContainer
  .carouselTextContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }

  // Carousel Container
  .carouselContainer {
    max-width: 590px;
    box-shadow: 0px 5px 30px rgba(9, 30, 66, 0.15);
    border-radius: 6px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .carouselContainer div {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  // Carousel Images
  .carouselContainer img {
    display: block;
    width: 100%;
    padding: 75px 115px 30px 115px;
    margin: 0 auto;
  }

  // Carousel Logo
  .biciLogo {
    padding: 0px !important;
    margin: 0px 0px 45px 0px !important;
    display: block;
    width: 100%;
    max-width: 120px;
    max-height: 16px;
    object-fit: contain;
  }

  // Carousel Arrows
  .carouselContainer button {
    opacity: 100 !important;
    padding: 15px !important;
    transition: 0.2s all !important;
    color: var(--black) !important;
  }

  .carouselContainer button::before {
    border: none !important;
    content: url("images/home/bicisAseguradas/arrows/arrowR.svg") !important;
  }

  .carouselContainer button:nth-child(1)::before {
    content: url("images/home/bicisAseguradas/arrows/arrowL.svg") !important;
  }

  .carouselContainer button:hover {
    background-color: transparent !important;
    transform: scale(1.3) !important;
  }

  // Info Container
  .infoContainer {
    max-width: 565px;
  }

  // Title
  .infoContainer h2 {
    margin: 0px 0px 40px 0px;
    color: var(--black);
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 2.2em;
    letter-spacing: -0.015em;
  }

  // Text
  .infoContainer p {
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 1em;
    line-height: 28px;
    margin: 0px 0px 0px 0px;
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Carousel Title
    .carouselContainer p {
      font-size: 1.1em;
    }

    // Title
    .infoContainer h2 {
      font-size: 2em;
    }

    // Text
    .infoContainer p {
      font-size: 0.96em;
    }
  }

  // 1600px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1600}) {
    max-width: 1100px;

    // Carousel Container
    .carouselContainer {
      max-width: 525px;
    }

    // Carousel Images
    .carouselContainer img {
      padding: 75px 115px 30px 115px;
    }

    // Info Container
    .infoContainer {
      max-width: 505px;
    }
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Carousel Title
    .carouselContainer p {
      font-size: 1em;
    }

    // Title
    .infoContainer h2 {
      font-size: 1.9em;
    }

    // Text
    .infoContainer p {
      font-size: 0.938em;
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    max-width: 1000px;
    margin: 130px 0px 0px 0px;

    // Info Container
    .infoContainer {
      max-width: 425px;
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
      flex-direction: row;
    }

    .infoContainer p {
      width: 100%;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    max-width: 850px;
    margin: 110px 0px 0px 0px;

    // Carousel Container
    .carouselContainer {
      max-width: 450px;
    }

    // Carousel Images
    .carouselContainer img {
      padding: 65px 90px 20px 90px;
    }

    // Info Container
    .infoContainer {
      max-width: 350px;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    max-width: 700px;

    // Carousel Container
    .carouselContainer {
      max-width: 390px;
    }

    // Carousel Images
    .carouselContainer img {
      padding: 45px 70px 20px 70px;
    }

    // Info Container
    .infoContainer {
      max-width: 280px;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    max-width: 600px;
    flex-direction: column-reverse;

    // CarouselTextContainer
    .carouselTextContainer {
      max-width: 600px;
      flex-direction: column-reverse;
      justify-content: center;
    }

    // Carousel Container
    .carouselContainer {
      width: 80%;
      max-width: none;
      margin: 40px 0px 0px 0px;
    }

    // Carousel Images
    .carouselContainer img {
      padding: 45px 90px 20px 90px;
    }

    // Info Container
    .infoContainer {
      width: 100%;
      max-width: none;
      justify-content: center;
    }

    // Title
    .infoContainer h2 {
      width: 100%;
      margin: 0px 0px 20px 0px;
      text-align: center;
    }

    // Text
    .infoContainer p {
      text-align: center;
    }
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    max-width: 540px;
    margin: 80px 0px 0px 0px;

    // CarouselTextContainer
    .carouselTextContainer {
      max-width: 540px;
    }
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    max-width: 480px;

    // CarouselTextContainer
    .carouselTextContainer {
      max-width: 480px;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    max-width: 400px;
    margin: 70px 0px 0px 0px;

    // CarouselTextContainer
    .carouselTextContainer {
      max-width: 400px;
    }

    // Carousel Container
    .carouselContainer {
      width: 100%;
      max-width: none;
      margin: 40px 0px 0px 0px;
    }

    // Title
    .infoContainer h2 {
      text-align: left;
    }

    // Text
    .infoContainer p {
      text-align: left;
    }
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    max-width: 88%;

    // CarouselTextContainer
    .carouselTextContainer {
      max-width: 88%;
    }

    // Carousel Images
    .carouselContainer img {
      padding: 45px 60px 20px 60px;
    }
  }

  // 340px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile340}) {
    // Carousel Images
    .carouselContainer img {
      padding: 50px 50px 20px 50px;
    }
  }
`;

export default Container;
